"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFieldWasOperator = exports.isFieldValueOperator = exports.isFieldChangedOperator = exports.isFieldChangedTimePredicateOperatorValue = exports.FIELD_OPERATOR_IS_NOT = exports.FIELD_OPERATOR_IS = exports.FIELD_OPERATOR_LIKE_EUALS = exports.FIELD_OPERATOR_LIKE = exports.FIELD_OPERATOR_NOT_IN = exports.FIELD_OPERATOR_IN = exports.FIELD_OPERATOR_LT_EQUALS = exports.FIELD_OPERATOR_GT_EQUALS = exports.FIELD_OPERATOR_LT = exports.FIELD_OPERATOR_GT = exports.FIELD_OPERATOR_NOT_EQUALS = exports.FIELD_OPERATOR_EQUALS = exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_BY = exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_DURING = exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_ON = exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_TO = exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_FROM = exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_AFTER = exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_BEFORE = exports.FIELD_WAS_OPERATOR_WAS_NOT = exports.FIELD_WAS_OPERATOR_WAS_NOT_IN = exports.FIELD_WAS_OPERATOR_WAS_IN = exports.FIELD_WAS_OPERATOR_WAS = exports.FIELD_CHANGED_OPERATOR_CHANGED = exports.COMPOUND_CLAUSE_NOT = exports.COMPOUND_CLAUSE_OR = exports.COMPOUND_CLAUSE_AND = void 0;
exports.COMPOUND_CLAUSE_AND = 'and';
exports.COMPOUND_CLAUSE_OR = 'or';
exports.COMPOUND_CLAUSE_NOT = 'not';
exports.FIELD_CHANGED_OPERATOR_CHANGED = 'changed';
exports.FIELD_WAS_OPERATOR_WAS = 'was';
exports.FIELD_WAS_OPERATOR_WAS_IN = 'was in';
exports.FIELD_WAS_OPERATOR_WAS_NOT_IN = 'was not in';
exports.FIELD_WAS_OPERATOR_WAS_NOT = 'was not';
const FIELD_WAS_OPERATORS = [
    exports.FIELD_WAS_OPERATOR_WAS,
    exports.FIELD_WAS_OPERATOR_WAS_IN,
    exports.FIELD_WAS_OPERATOR_WAS_NOT_IN,
    exports.FIELD_WAS_OPERATOR_WAS_NOT
];
exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_BEFORE = 'before';
exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_AFTER = 'after';
exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_FROM = 'from';
exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_TO = 'to';
exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_ON = 'on';
exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_DURING = 'during';
exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_BY = 'by';
const FIELD_CHANGED_TIME_PREDICATE_OPERATORS = [
    exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_BEFORE,
    exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_AFTER,
    exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_FROM,
    exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_TO,
    exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_ON,
    exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_DURING,
    exports.FIELD_CHANGED_TIME_PREDICATE_OPERATOR_BY
];
exports.FIELD_OPERATOR_EQUALS = '=';
exports.FIELD_OPERATOR_NOT_EQUALS = '!=';
exports.FIELD_OPERATOR_GT = '>';
exports.FIELD_OPERATOR_LT = '<';
exports.FIELD_OPERATOR_GT_EQUALS = '>=';
exports.FIELD_OPERATOR_LT_EQUALS = '<=';
exports.FIELD_OPERATOR_IN = 'in';
exports.FIELD_OPERATOR_NOT_IN = 'not in';
exports.FIELD_OPERATOR_LIKE = '~';
exports.FIELD_OPERATOR_LIKE_EUALS = '~=';
exports.FIELD_OPERATOR_IS = 'is';
exports.FIELD_OPERATOR_IS_NOT = 'is not';
const FIELD_VALUE_OPERATORS = [
    exports.FIELD_OPERATOR_EQUALS,
    exports.FIELD_OPERATOR_NOT_EQUALS,
    exports.FIELD_OPERATOR_GT,
    exports.FIELD_OPERATOR_LT,
    exports.FIELD_OPERATOR_GT_EQUALS,
    exports.FIELD_OPERATOR_LT_EQUALS,
    exports.FIELD_OPERATOR_IN,
    exports.FIELD_OPERATOR_NOT_IN,
    exports.FIELD_OPERATOR_LIKE,
    exports.FIELD_OPERATOR_LIKE_EUALS,
    exports.FIELD_OPERATOR_IS,
    exports.FIELD_OPERATOR_IS_NOT
];
// Guards
exports.isFieldChangedTimePredicateOperatorValue = (operator) => {
    return FIELD_CHANGED_TIME_PREDICATE_OPERATORS.some(valueOperator => valueOperator === operator);
};
exports.isFieldChangedOperator = (operator) => {
    return operator === exports.FIELD_CHANGED_OPERATOR_CHANGED;
};
exports.isFieldValueOperator = (operator) => {
    return FIELD_VALUE_OPERATORS.some(valueOperator => valueOperator === operator);
};
exports.isFieldWasOperator = (operator) => {
    return FIELD_WAS_OPERATORS.some(wasOperator => wasOperator === operator);
};
//# sourceMappingURL=operator.js.map